<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex">
      <!-- LOGO -->
      <div class="navbar-brand-box">
        <a routerLink="" class="logo logo-dark">
          <span class="logo-sm">
            <img src="assets/images/logo.svg" alt="" height="22">
          </span>
          <span class="logo-lg">
            <img src="assets/images/logo-dark.png" alt="" height="27">
          </span>
        </a>
        <!-- 
        <a routerLink="/buyer/marketplace" class="logo logo-light">
          <span class="logo-sm">
            <img src="../../../assets/images/connekkt-media-logo.png" alt="" height="22">
          </span>
          <span class="logo-lg">
            
             <img src="assets/newImages/connekkt-log" alt="alternative" height="52">
          </span>
        </a> -->
        <a [routerLink]="logoRoute" class="logo logo-light">
          <span class="logo-sm">
            <img src="../../../assets/images/connekkt-media-logo.png" alt="" height="22">
          </span>
          <span class="logo-lg">
            <!-- <img src="assets/images/connekkt-web-logo-white.png" alt="" height="52"> -->
            <img src="assets/newImages/connekkt-logo.png" alt="alternative" height="40">
          </span>
        </a>


      </div>

      <button type="button" class="btn btn-sm px-3 font-size-16 d-lg-none header-item" (click)="toggleMenubar()">
        <i class="fa fa-fw fa-bars"></i>
      </button>


    </div>
<!-- <div class="d-flex align-items-center me-3">
  <div class="role-toggle">
  <div 
    class="toggle-option"
    [class.active]="selectedRole === 'buyer'"
    (click)="switchRole('buyer')">
    Buyer
  </div>

  <div 
    class="toggle-option"
    [class.active]="selectedRole === 'seller'"
    (click)="switchRole('seller')">
    Seller
  </div>
</div>

</div> -->
    <div class="d-flex">


<!-- 
      <div class="dropdown d-none d-lg-inline-block me-1">
        <button type="button" class="btn header-item noti-icon" data-toggle="fullscreen" (click)="fullscreen()">
          <i class="bx bx-fullscreen"></i>
        </button>
      </div>

      <div class="dropdown d-inline-block" ngbDropdown>
        <button type="button" class="btn header-item noti-icon" id="page-header-notifications-dropdown"
          ngbDropdownToggle (click)="moveChatlogs()">
          <i class="bx bx-bell bx-tada"></i>
          <span *ngIf="data2 !=0" class="badge bg-danger rounded-pill">{{data2}} </span>
        </button>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" ngbDropdownMenu
          aria-labelledby="page-header-notifications-dropdown">



        </div>
      </div> -->



      <div class="dropdown d-inline-block" ngbDropdown>
        <button type="button" class="btn header-item" id="page-header-user-dropdown" ngbDropdownToggle>
          <!-- <img class="rounded-circle header-profile-user" src="assets/images/users/ic_default.png" alt="Header Avatar"> -->
          <img class="rounded-circle header-profile-user" [src]="profileImage" alt="Header Avatar"
            (error)="profileImage = 'assets/images/users/ic_default.png'">
          <span class="d-none d-xl-inline-block ms-1 text-capitalize">{{ user.first_name + " " + user.last_name}}</span>
          <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
          <!-- item-->
          <a class="dropdown-item" href="javascript: void(0);" (click)="gotoProfile()"><i
              class="bx bx-user font-size-16 align-middle me-1"></i>
            {{ 'HEADER.LOGIN.PROFILE' | translate}}</a>
          <a class="dropdown-item" href="javascript: void(0);" (click)="gotoChangePassword()"><i
              class="bx bx-edit-alt font-size-16 align-middle me-1"></i>
            Change Password</a>

          <a class="dropdown-item" href="javascript: void(0);" (click)="gotoWatchList()"  *ngIf="userType === '1'" ><i
              class="bx bx-list-check font-size-16 align-middle me-1"></i>
            Watch List</a>
          <!-- <a class="dropdown-item" href="javascript: void(0);"><i
              class="bx bx-wallet font-size-16 align-middle me-1"></i>{{ 'HEADER.LOGIN.MY_WALLET' | translate}}</a> -->
          <!--<a class="dropdown-item d-block" href="javascript: void(0);"><span
              class="badge bg-success float-end">11</span><i class="bx bx-wrench font-size-16 align-middle me-1"></i>{{
            'HEADER.LOGIN.SETTINGS' | translate}} </a>-->
          <div class="dropdown-divider"></div>
          <a class="dropdown-item text-danger" href="javascript: void(0);" (click)="logout()"><i
              class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>
            {{ 'HEADER.LOGIN.LOGOUT' | translate}}</a>
        </div>
      </div>
    </div>
  </div>
</header>

<div class="topnav" *ngIf="!isTopNavDisabled">
  <div class="container-fluid">
    <nav class="navbar navbar-light navbar-expand-lg topnav-menu active responsive-topnav">
      <div class="collapse navbar-collapse active" id="topnav-menu-content">
        <ul class="navbar-nav">
          <ng-container *ngFor="let item of menuItems">
            <li class="nav-item dropdown">
              <!-- <a class="nav-link dropdown-toggle arrow-none" *ngIf="!item.subItems" href="javascript: void(0);"
                id="topnav-components" [routerLink]="item.link" role="button" routerLinkActive="active" (click)="itemRemove(item.label)"> -->
              <a class="nav-link dropdown-toggle arrow-none" *ngIf="!item.subItems" href="javascript: void(0);"
                id="topnav-components" [routerLink]="item.link" routerLinkActive="active-link" role="button"
                (click)="onMenuItemClick(item)">



                <!--  -->
                <div *ngIf="item.label == 'CHAT';else other_content">
                  <span *ngIf="data1 !=0" class="badge chatbadge bg-danger rounded-pill">{{data1}}</span>
                  <!-- <i class="bx {{item.icon}} me-2"></i> -->
                   <img src="assets/newImages/chat.png" alt="">
                  {{ item.label | translate }}
                </div>

                <ng-template #other_content>
                  <!-- <i class="bx {{item.icon}} me-2"></i> -->
                   <img *ngIf="iconImageMap[item.icon]; "
     [src]="iconImageMap[item.icon]"
     class="menu-icon"
     alt="{{ item.label }}">
                  {{ item.label | translate }}
                </ng-template>

                <!--  -->

                <div class="arrow-down" *ngIf="hasItems(item)"></div>
                <!-- <span class="badge rounded-pill bg-{{item.badge.variant}} float-end" *ngIf="item.badge">05</span> -->
              </a>


              <a *ngIf="item.subItems" class="nav-link " routerLink="/seller/library-page" (click)="onMenuClick($event)"
                href="javascript: void(0);" id="topnav-components" role="button">
                <!-- <i class="bx {{item.icon}} me-1"></i> -->
                 <img src="assets/newImages/library.png" alt="">
                {{item.label| translate }}
                <!-- <div class="arrow-down"></div> -->
              </a>

              <!-- <div class="dropdown-menu" aria-labelledby="topnav-dashboard" *ngIf="hasItems(item)">
                <ng-template ngFor let-i="index" let-subitem [ngForOf]="item.subItems">
                  <a class="col dropdown-item side-nav-link-ref" *ngIf="!hasItems(subitem)" href="javascript: void(0);"
                    [routerLink]="subitem.link" routerLinkActive="active">{{subitem.label | translate }}</a>

                  <div class="dropdown" *ngIf="hasItems(subitem)">
                    <a class="dropdown-item dropdown-toggle" href="javascript: void(0);"
                      (click)="onMenuClick($event)">{{ subitem.label | translate }}
                      <div class="arrow-down"></div>
                    </a>
                    <div class="dropdown-menu">
                      <ng-template ngFor let-subSubitem [ngForOf]="subitem.subItems">
                        <a class="dropdown-item side-nav-link-ref" *ngIf="!hasItems(subSubitem)"
                          href="javascript: void(0);" [routerLink]="subSubitem.link" routerLinkActive="active">{{
                          subSubitem.label | translate }}</a>
                        <div class="dropdown" *ngIf="hasItems(subSubitem)">

                          <a class="dropdown-item dropdown-toggle" href="javascript: void(0);"
                            (click)="onMenuClick($event)">{{ subSubitem.label | translate }}
                            <div class="arrow-down"></div>
                          </a>
                          <div class="dropdown-menu">
                            <ng-template ngFor let-subSubSubitem [ngForOf]="subSubitem.subItems">
                              <a class="dropdown-item side-nav-link-ref" href="javascript: void(0);"
                                [routerLink]="subSubSubitem.link" routerLinkActive="active">{{ subSubSubitem.label |
                                translate }}</a>
                            </ng-template>
                          </div>
                        </div>
                      </ng-template>
                    </div>
                  </div>
                </ng-template>
              </div> -->
            </li>
            
          </ng-container>

        </ul>

      </div>

     
   <div class="noti-container topnav-actions">      
  <div class="dropdown d-inline-block" ngbDropdown>
        <div class="notifications">
        <!-- <button type="button" class="btn header-item noti-icon" id="page-header-notifications-dropdown"
          ngbDropdownToggle (click)="moveChatlogs()">
          <i class="bx bx-bell bx-tada"></i> 
          <span *ngIf="data2 !=0" class="badge bg-danger rounded-pill">{{data2}}234 </span>

        </button>
        <div>Notification</div> -->
           <button type="button" class="btn header-item noti-icon notifications" id="page-header-notifications-dropdown"
          ngbDropdownToggle (click)="moveChatlogs()">
          
          <!-- <i class="bx bx-bell bx-tada"></i>  -->
           <img src="assets/newImages/notification.png" alt=""><div> Notification </div>
          <span *ngIf="data2 !=0" class="badge bg-danger rounded-pill">{{data2}} </span>

        </button>
      
        </div>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" ngbDropdownMenu
          aria-labelledby="page-header-notifications-dropdown">



        </div>
      </div>
       <div class="dropdown d-none d-lg-inline-block me-1 ">
        <!-- <button type="button" class="btn header-item noti-icon" data-toggle="fullscreen" (click)="fullscreen()">
          <i class="bx bx-fullscreen"></i>
        </button> -->
         <button type="button"class="btn header-item noti-icon notifications" (click)="gotoProfile()" >
          <img src="assets/newImages/setting.png" alt="">Account & Settings
        </button>
      </div>
      </div>

    </nav>
  </div>
</div>



<!-- <div class="modal fade" id="offerModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content custom-offer-modal">
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>

      <div class="modal-header  border-0 " style="justify-content: center;">
        <h5 class="modal-title fw-bold text-success">
          Connekkt Xchange Offer feature : Contact-Propose-Secure
        </h5>
      </div>

      <div class="modal-body">
        <p>
          The Connekkt Xchange Offer Page is designed to help buyers submit a
          licensing offer for a selected title in a structured manner. The process is
          divided into four easy steps so that all necessary details are captured for
          a smooth transaction:
        </p>

        <div class="offer-section">
          <h6 class="text-success">Rights & Details</h6>
          <ul>
            <li><b>Title:</b> Choose the title you want to make an offer for.</li>
            <li><b>Territories:</b> Select the territories where you want the rights.</li>
            <li><b>Licensing Period:</b> Enter the start and end dates for the license duration.</li>
            <li><b>Rights:</b> Select the rights you wish to acquire (e.g., streaming, TV, digital).</li>
          </ul>
        </div>

        <div class="offer-section">
          <h6 class="text-success">Language & Specs</h6>
          <p>Specify the languages, versions, and technical specifications required.</p>
        </div>

        <div class="offer-section">
          <h6 class="text-success">Payment Terms</h6>
          <p>Define your proposed payment structure, terms, and conditions.</p>
        </div>

        <div class="offer-section">
          <h6 class="text-success">Confirm Details</h6>
          <p>Review all the information you’ve entered before submitting your offer.</p>
        </div>
      </div>

      <div class="modal-footer border-0">
        <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="proceedToOffer()">Proceed</button>
      </div>
    </div>
  </div>
</div> -->
<div class="modal fade" id="offerModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content custom-offer-modal">
      <div class="modal-header border-0" >
        <h5 class="modal-title fw-bold text-success">
          Connekkt Xchange Offer feature : Contact-Propose-Secure
        </h5>
      </div>

      <div class="modal-body">
        <div class="row">
          <div class="col-md-7">
            <p>
              The Connekkt Xchange Offer Page is designed to help buyers submit a licensing
              offer for a selected title in a structured manner. The process is divided into
              four easy steps so that all necessary details are captured for a smooth
              transaction:
            </p>

            <div class="offer-section">
              <h6 class="text-success">Rights & Details</h6>
              <ul>
                <li><b>Title:</b> Choose the title you want to make an offer for.</li>
                <li><b>Territories:</b> Select the territories where you want the rights.</li>
                <li><b>Licensing Period:</b> Enter the start and end dates for the license duration.</li>
                <li><b>Rights:</b> Select the rights you wish to acquire (e.g., streaming, TV, digital).</li>
              </ul>
            </div>

            <div class="offer-section">
              <h6 class="text-success">Language & Specs</h6>
              <p>Specify the languages, versions, and technical specifications required.</p>
            </div>

            <div class="offer-section">
              <h6 class="text-success">Payment Terms</h6>
              <p>Define your proposed payment structure, terms, and conditions.</p>
            </div>

            <div class="offer-section">
              <h6 class="text-success">Confirm Details</h6>
              <p>Review all the information you’ve entered before submitting your offer.</p>
            </div>
          </div>

          <div class="col-md-5 text-center d-flex align-items-center justify-content-center">
            <img src="assets/images/offer-page.png" alt="Offer Illustration" class="img-fluid modal-illustration">
          </div>
        </div>
      </div>

      <div class="modal-footer border-0" style="justify-content: center;">
        <button type="button" class="btn btn-outline-secondary" style="color: white;" data-bs-dismiss="modal">Cancel</button>
        <button *ngIf="skipped!=1"  type="button" class="btn btn-primary" (click)="proceedToOffer()">Skip for Future</button>
      </div>
    </div>
  </div>
</div>
<ng-template #roleModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">
      You are not registered for this profile
    </h5>
  </div>

  <div class="modal-body">
    Do you want to continue with the registration process?
  </div>

  <div class="modal-footer">
    <button class="btn btn-secondary" (click)="modal.dismiss()">
      Cancel
    </button>
    <button class="btn btn-primary" (click)="confirmRoleChange(modal)">
      Yes
    </button>
  </div>
</ng-template>
